<div class="infoFormDv">
  <i class="fa fa-times closeInfoDv" aria-hidden="true" (click)="closeDialog()"></i>
  <div>
    <div class="TextDv">
      <h1>{{data.bookingInfo.title}}</h1>
      <p>{{data.bookingInfo.body}}</p>
    </div>
    <div class="btnDv">
      <a (click)="closeDialog()">Ok</a>
    </div>
  </div>
</div>
